import {
    ADD,
    DECREASE_QUANTITY,
    INCREASE_QUANTITY,
    IS_PRODUCT_PAGE
} from "./actionTypes";

export const addProduct = (product) => {
    return {
        type: ADD,
        payload: product,
    };
};

export const increaeQuantity = (payload) => {
    return {
        type: INCREASE_QUANTITY,
        payload: payload,
    };
};

export const decreaseQuantity = (productId) => {
    return {
        type: DECREASE_QUANTITY,
        payload: productId,
    };
};

export const isProductPage = (isProductPage) => {
    return {
        type: IS_PRODUCT_PAGE,
        payload: isProductPage,
    };
};
